/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The data needed to create a new tenant and an owner user.
 * @export
 * @interface SignupMachineRequest
 */
export interface SignupMachineRequest {
    /**
     * The name of the tenant to create.
     * @type {string}
     * @memberof SignupMachineRequest
     */
    tenantName: string;
    /**
     * The subdomain of the tenant to create. Used as the subdomain in the URL.
     * @type {string}
     * @memberof SignupMachineRequest
     */
    tenantSubdomain: string;
}

/**
 * Check if a given object implements the SignupMachineRequest interface.
 */
export function instanceOfSignupMachineRequest(value: object): value is SignupMachineRequest {
    if (!('tenantName' in value) || value['tenantName'] === undefined) return false;
    if (!('tenantSubdomain' in value) || value['tenantSubdomain'] === undefined) return false;
    return true;
}

export function SignupMachineRequestFromJSON(json: any): SignupMachineRequest {
    return SignupMachineRequestFromJSONTyped(json, false);
}

export function SignupMachineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupMachineRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantName': json['tenant_name'],
        'tenantSubdomain': json['tenant_subdomain'],
    };
}

export function SignupMachineRequestToJSON(json: any): SignupMachineRequest {
    return SignupMachineRequestToJSONTyped(json, false);
}

export function SignupMachineRequestToJSONTyped(value?: SignupMachineRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenant_name': value['tenantName'],
        'tenant_subdomain': value['tenantSubdomain'],
    };
}

